export default "__VITE_ASSET__64f3fd09__"